// extracted by mini-css-extract-plugin
module.exports = {"ImportantInfos":"ImportantInfos_ImportantInfos__1qyfX","InfosList":"ImportantInfos_InfosList__1uS1U"};